__turbopack_context__.v({
  "blockquote": "richtext-module-scss-module__cp7rsq__blockquote",
  "highlight": "richtext-module-scss-module__cp7rsq__highlight",
  "placeholder": "richtext-module-scss-module__cp7rsq__placeholder",
  "table": "richtext-module-scss-module__cp7rsq__table",
});
